import { Quicksave } from 'src/components/HomePage/ModalsContent/Quicksave'
import { AddCard } from 'src/components/HomePage/ModalsContent/AddCard'
import { ConfirmQuickSaveMasterCard } from 'src/components/HomePage/ModalsContent/ConfirmQuickSave'
import { Plans } from 'src/components/HomePage/ModalsContent/plans/Plans'
import { useTypedSelector } from 'src/redux/index'
import { AutomatedSavings } from 'src/components/Xcontest/SavingsFrequency/AutomatedSavings'
import { AutomateUpdate } from 'src/components/HomePage/ModalsContent/createPlans/update-plans/automate-update'
import { ExtendDate } from 'src/components/HomePage/ModalsContent/createPlans/update-plans/extend-date'
import {
  Success,
  ShowwBvn,
  SuccessFull,
  TokenSentNumber,
  CardSuccessFull,
  TransferSuccessFull,
  InvestmentSuccessFull,
  CollaboSuccessFull,
} from 'src/components/HomePage/ModalsContent/Success'
import { Failed, Faillure } from 'src/components/HomePage/ModalsContent/Failed'
import { Withdrawal } from 'src/components/HomePage/ModalsContent/Withdrawal'
import { ConfirmWithdrawal } from 'src/components/HomePage/ModalsContent/ConfirmWithdrawal'
import { AddBankCard } from 'src/components/HomePage/ModalsContent/AddBankCard'
import {
  Permission,
  Confirmation,
  InvestmentConfirmation,
} from 'src/components/HomePage/ModalsContent/Permission'
import { CreatePin } from 'src/components/HomePage/ModalsContent/CreatePin/CreatePin'
import { CreateTarget } from 'src/components/HomePage/ModalsContent/TargetPlanModal/CreateTarget'
import { CreateCollaboOne } from 'src/components/HomePage/ModalsContent/Collabo/Collabo-one'
import { CreateCollaboTwo } from 'src/components/HomePage/ModalsContent/Collabo/Collabo-two'
import { CreateCollaboThree } from 'src/components/HomePage/ModalsContent/Collabo/Collabo-three'
import { CreateCollaboFour } from 'src/components/HomePage/ModalsContent/Collabo/Collabo-four'
import { PlanName } from 'src/components/HomePage/ModalsContent/createPlans/PlanName'
import { PlanTimeLine } from 'src/components/HomePage/ModalsContent/createPlans/PlanTimeLine'
import { TargetTimeLine } from 'src/components/HomePage/ModalsContent/createTargetPlans/PlanTimeLine'
import { PlanAmount } from 'src/components/HomePage/ModalsContent/createPlans/PlanAmount'
import { PlanFrequency } from 'src/components/HomePage/ModalsContent/createPlans/PlanFrequency'
import { PlanOnboarding } from 'src/components/HomePage/ModalsContent/createPlans/PlanOnboarding'
import { TargetOnboarding } from 'src/components/HomePage/ModalsContent/createPlans/TargetOnboarding/TargetOnboarding'
import { TargetName } from 'src/components/HomePage/ModalsContent/createTargetPlans/TargetName'
import { TargetFrequency } from 'src/components/HomePage/ModalsContent/createTargetPlans/PlanFrequency'
import { CreateTargetContinue } from 'src/components/HomePage/ModalsContent/TargetPlanModal/CreateTargetContinue'
import { EmergencySavings } from 'src/components/HomePage/ModalsContent/EmergencySavings'
import {
  TransferEmergencySavings,
  TransferEmergencyUsers,
} from 'src/components/HomePage/ModalsContent/TransferEmergency'
import { InvestInfo } from 'src/components/HomePage/ModalsContent/InvestInfo'
import { AmountToInvest } from 'src/components/HomePage/ModalsContent/AmountToInvest'
import { ReviewInvestment } from 'src/components/HomePage/ModalsContent/ReviewInvestment'
import { AddCollaborator } from 'src/components/HomePage/ModalsContent/Collabo/AddCollaborator'
import { BankSetings } from 'src/components/HomePage/ModalsContent/BankSettings/BankSettings'
import { ChangePIN } from 'src/components/HomePage/ModalsContent/changePin/Changepin'
import { BaseProfileSetings } from 'src/components/HomePage/ModalsContent/profileData/ProfileDataSetting'
// } from 'src/components/HomePage/ModalsContent/BankSettings/BankSettings'
import { CardSettings } from 'src/components/HomePage/ModalsContent/Cards/CardSettings'
import { Preferences } from 'src/components/HomePage/ModalsContent/preference/Preferences'
import { SecurityQuestion } from 'src/components/HomePage/ModalsContent/SecurityQuestion'
import {
  InterestSettings,
  NotificationSettings,
} from 'src/components/HomePage/ModalsContent/InterestSettings'
import { KycSettings } from 'src/components/HomePage/ModalsContent/KycSettings'
import { NextOfKinSettings } from 'src/components/HomePage/ModalsContent/nextOfKinsetting/NextOfKinSettings'
import { PasswordSettings } from 'src/components/HomePage/ModalsContent/changePassword/Password'
import { BvnSettings } from 'src/components/HomePage/ModalsContent/BvnSettings'
import { Mystory } from 'src/components/HomePage/ModalsContent/Mystory'
import { SavingsFrequency } from 'src/components/HomePage/ModalsContent/TargetPlanModal/SavingsFrequency'
import { Logout } from 'src/components/HomePage/ModalsContent/Logout/Logout'
import { Profiles } from 'src/components/HomePage/ModalsContent/profile/ProfileSettings'
import Help from 'src/components/HomePage/ModalsContent/Help/Help'
import Earn from 'src/components/HomePage/ModalsContent/Earn/Earn'
import BankDelete from 'src/components/HomePage/ModalsContent/BankSettings/BankDelete'
import { PlanCreatedDetails } from 'src/components/HomePage/ModalsContent/createPlans/PlanDetails'
import { TargetCreatedDetails } from 'src/components/HomePage/ModalsContent/createTargetPlans/PlanDetails'
import { PlanAmountToSave } from 'src/components/HomePage/ModalsContent/payment-plans/PlansAmount'
import { PaymentDetails } from 'src/components/HomePage/ModalsContent/payment-plans/PaymentDetail'
import BankTransfer from 'src/components/Payment/BankTransfer/BankTransfer'
import { QuicksaveAmount } from 'src/components/HomePage/ModalsContent/payment-plans/QuicksaveAmount'
import PlanDetail from 'src/components/HomePage/ModalsContent/plans/PlanDetail'
import { BankAccountsDetail } from 'src/components/HomePage/ModalsContent/BankSettings/BankAccountsDetail'
import ContestOnBoarding from 'src/components/Xcontest/OnBoarding/ContestOnBoarding'
import ContentSavingFreq from 'src/components/Xcontest/ContestSavingFreq/ContentSavingFreq'
import ContestCheckout from 'src/components/Xcontest/Checkout/ContestCheckout'
import JoinedContestDetail from 'src/components/Xcontest/MyContest/JoinedContest/JoinedContestDetail'
let MODALSPATH = [
  {
    id: 'bank-detail-page',
    title: <BankAccountsDetail />,
  },

  {
    id: 'name',
    title: <PlanName />,
  },

  {
    id: 'onboarding',
    title: <PlanOnboarding />,
  },

  {
    id: 'amount',
    title: <PlanAmount />,
  },
  {
    id: 'timeline',
    title: <PlanTimeLine />,
  },
  {
    id: 'create-collabo-two',
    title: <CreateCollaboTwo />,
  },
  {
    id: 'create-collabo-three',
    title: <CreateCollaboThree />,
  },
  {
    id: 'create-collabo-four',
    title: <CreateCollaboFour />,
  },
  {
    id: 'change-pin',
    title: <ChangePIN />,
  },
  {
    id: 'create-pin',
    title: <CreatePin />,
  },
  {
    id: 'plans',
    title: <Plans />,
  },
  {
    id: 'profiles',
    title: <Profiles />,
  },
  {
    id: 'savings-frequency',
    title: <SavingsFrequency />,
  },
  {
    id: 'my-story',
    title: <Mystory />,
  },
  {
    id: 'bvn-setting',
    title: <BvnSettings />,
  },
  {
    id: 'show-bvn',
    title: <ShowwBvn />,
  },
  {
    id: 'next-of-kin-setting',
    title: <NextOfKinSettings />,
  },
  {
    id: 'password-setting',
    title: <PasswordSettings />,
  },
  {
    id: 'token-sent',
    title: <TokenSentNumber />,
  },
  {
    id: 'notification-setting',
    title: <NotificationSettings />,
  },
  {
    id: 'kyc-setting',
    title: <KycSettings />,
  },
  {
    id: 'interest-settings',
    title: <InterestSettings />,
  },
  {
    id: 'profile-setting',
    title: <BaseProfileSetings />,
  },

  {
    id: 'security-question',
    title: <SecurityQuestion />,
  },
  {
    id: 'preference',
    title: <Preferences />,
  },
  {
    id: 'card-setting',
    title: <CardSettings />,
  },
  {
    id: 'bank-delete',
    title: <BankDelete />,
  },
  {
    id: 'bank-setting',
    title: <BankSetings />,
  },
  {
    id: 'bank-transfer',
    title: <BankTransfer />,
  },
  {
    id: 'collabo-successfull',
    title: <CollaboSuccessFull />,
  },
  {
    id: 'quicksave',
    title: <Quicksave />,
  },
  {
    id: 'quicksave-one',
    title: <AddCard />,
  },
  {
    id: 'quicksave-two',
    title: <ConfirmQuickSaveMasterCard />,
  },
  {
    id: 'success',
    title: <Success />,
  },
  {
    id: 'failed',
    title: <Failed />,
  },
  {
    id: 'withdrawal',
    title: <Withdrawal />,
  },
  {
    id: 'confirm-withdrawal',
    title: <ConfirmWithdrawal />,
  },
  {
    id: 'successful',
    title: <SuccessFull />,
  },
  {
    id: 'failure',
    title: <Faillure />,
  },
  {
    id: 'add-bank-card',
    title: <AddBankCard />,
  },
  {
    id: 'permission',
    title: <Permission />,
  },
  {
    id: 'card-successfull',
    title: <CardSuccessFull />,
  },
  {
    id: 'create-target',
    title: <CreateTarget />,
  },
  {
    id: 'create-target-continue',
    title: <CreateTargetContinue />,
  },
  {
    id: 'emergency-saving-modal',
    title: <EmergencySavings />,
  },
  {
    id: 'transfer-emergency-savings',
    title: <TransferEmergencySavings />,
  },
  {
    id: 'transfer-emergency-user',
    title: <TransferEmergencyUsers />,
  },
  {
    id: 'confirmation',
    title: <Confirmation />,
  },
  {
    id: 'transfer-successFull',
    title: <TransferSuccessFull />,
  },
  {
    id: 'invest-information',
    title: <InvestInfo />,
  },
  {
    id: 'amount-to-invest',
    title: <AmountToInvest />,
  },
  {
    id: 'review-investment',
    title: <ReviewInvestment />,
  },
  {
    id: 'investment-confirmation',
    title: <InvestmentConfirmation />,
  },
  {
    id: 'investment-successFull',
    title: <InvestmentSuccessFull />,
  },
  {
    id: 'create-collabo',
    title: <CreateCollaboOne />,
  },
  {
    id: 'add-collaborator',
    title: <AddCollaborator />,
  },
]
let PAYMENT_PATH = [
  {
    id: 'general-payment-amount',
    title: <PlanAmountToSave />,
  },
  {
    id: 'general-payment-detail',
    title: <PaymentDetails />,
  },
  {
    id: 'plan-created-details',
    title: <PlanCreatedDetails />,
  },
  {
    id: 'general-automate',
    title: <AutomateUpdate />,
  },
  {
    id: 'general-extend-date',
    title: <ExtendDate />,
  },
  {
    id: 'general-frequency',
    title: <PlanFrequency />,
  },
]
let CONTEST_PAYMENT_PATH = [
  {
    id: 'contest-payment-amount',
    title: <PlanAmountToSave />,
  },
  {
    id: 'contest-payment-detail',
    title: <PaymentDetails />,
  },
  {
    id: 'contest-frequency',
    title: <AutomatedSavings />,
  },
]
let HELP_PATH = [
  {
    id: 'help',
    title: <Help />,
  },
]
let LOG_OUTPATH = [
  {
    id: 'logout',
    title: <Logout />,
  },
]
let EARN_PATH = [
  {
    id: 'earn',
    title: <Earn />,
  },
]
let TARGET_PAYMENT_PATH = [
  {
    id: 'target-payment-amount',
    title: <PlanAmountToSave />,
  },
  {
    id: 'target-payment-detail',
    title: <PaymentDetails />,
  },
  {
    id: 'target-name',
    title: <TargetName />,
  },
  {
    id: 'target-onboarding',
    title: <TargetOnboarding />,
  },
  {
    id: 'target-frequency',
    title: <TargetFrequency />,
  },
  {
    id: 'target-timeline',
    title: <TargetTimeLine />,
  },
  {
    id: 'target-automate',
    title: <AutomateUpdate />,
  },
  {
    id: 'target-extend-date',
    title: <ExtendDate />,
  },
  {
    id: 'target-details',
    title: <TargetCreatedDetails />,
  },
]
let HOMEPAGE_PATH = [
  {
    id: 'quicksave-amount',
    title: <QuicksaveAmount />,
  },
  {
    id: 'log-out',
    title: <Logout />,
  },
  {
    id: 'quicksave-payment-detail',
    title: <PaymentDetails />,
  },
]
let PATH: any = []
const GetInvestmentAllPath = () => {
  const investmentData = useTypedSelector((state) => state.invest.all?.plans)

  investmentData?.map((item: any) => {
    return PATH.push({ id: item?.id, title: `${(<PlanDetail />)}` })
  })
}
let CONTEST_PATH: any = [
  {
    id: 'contest-saving-freq',
    title: <ContentSavingFreq />,
  },
  {
    id: 'contest-checkout',
    title: <ContestCheckout />,
  },

  {
    id: 'joined_contest',
    title: <JoinedContestDetail />,
  },
]
let XCONTEST_PATH: any = [
  {
    id: 'contest-detail',
    title: <ContestOnBoarding />,
  },
]
const GetXcontestAllPath = () => {
  const allContest = useTypedSelector((state) => state.xcontest.all)

  allContest?.map((item: any) => {
    return XCONTEST_PATH.push({ id: item?.id, title: `${(<PlanDetail />)}` })
  })
}
let JOINED_CONTEST: any = []
const GetJoinedcontestAllPath = () => {
  const userContest = useTypedSelector((state) => state.xcontest.userContests)

  userContest?.map((item: any) => {
    return JOINED_CONTEST.push({
      id: item?.contest_id,
      title: `${(<PlanDetail />)}`,
    })
  })
}

let PLANS_PATH: any = []
const GetPlansAllPath = () => {
  const myPlans = useTypedSelector(
    (state) => state.userPlanReducer.myPlans?.plans
  )

  myPlans?.map((item: any) => {
    return PLANS_PATH.push({ id: item?.id, title: `${(<PlanDetail />)}` })
  })
}
let TARGET_PATH: any = []
const GetTargetPlansAllPath = () => {
  const myTargetPlans = useTypedSelector(
    (state) => state.userPlanReducer.myPlans?.plans
  )
  myTargetPlans?.map((item: any) => {
    return TARGET_PATH.push({ id: item?.id, title: `${(<PlanDetail />)}` })
  })
}
function getModalsPathId(id: any) {
  return MODALSPATH.find((image) => image.id === id)
}
function getLogoutModalsPathId(id: any) {
  return LOG_OUTPATH.find((image) => image.id === id)
}
function getModalsPaymentPathId(id: any) {
  return PAYMENT_PATH.find((image) => image.id === id)
}

function getModalsHomepagePathId(id: any) {
  return HOMEPAGE_PATH.find((image) => image.id === id)
}
function getModalsXContestPathId(id: any) {
  return CONTEST_PATH.find((image: any) => image.id === id)
}
function getModalstargetPaymentPathId(id: any) {
  return TARGET_PAYMENT_PATH.find((image) => image.id === id)
}
function getModalscontestPaymentPathId(id: any) {
  return CONTEST_PAYMENT_PATH.find((image: any) => image.id === id)
}
function getModalsHelpPathId(id: any) {
  return HELP_PATH.find((image) => image.id === id)
}
function getModalsEarnPathId(id: any) {
  return EARN_PATH.find((image) => image.id === id)
}
function getCustomInvestmentModalsPathId(id: any) {
  GetInvestmentAllPath()
  return PATH.find((image: any) => image.id === id)
}
function getCustomModalsPathId(id: any) {
  GetPlansAllPath()
  return PLANS_PATH.find((image: any) => image.id === id)
}
function getTargetModalsPathId(id: any) {
  GetTargetPlansAllPath()
  return TARGET_PATH.find((image: any) => image.id === id)
}
let CARD_PATH: any = []
const GetCardAllPath = () => {
  const cardsResult = useTypedSelector((state) => state.cards.myCards.cards)

  cardsResult?.map((item: any) => {
    return CARD_PATH.push({ id: item?.id, title: `${(<PlanDetail />)}` })
  })
}
function getCustomCardModalsPathId(id: any) {
  GetCardAllPath()
  return CARD_PATH.find((image: any) => image.id === id)
}

function getModalsContestPathId(id: any) {
  GetXcontestAllPath()
  return XCONTEST_PATH.find((image: any) => image.id === id)
}
function getJoinedContestPathId(id: any) {
  GetJoinedcontestAllPath()
  return JOINED_CONTEST.find((image: any) => image.id === id)
}

export {
  MODALSPATH,
  getModalsPathId,
  getCustomModalsPathId,
  getCustomInvestmentModalsPathId,
  getTargetModalsPathId,
  getModalsPaymentPathId,
  getModalstargetPaymentPathId,
  getModalsHomepagePathId,
  getModalsHelpPathId,
  getModalsEarnPathId,
  getModalsContestPathId,
  getModalsXContestPathId,
  getJoinedContestPathId,
  getModalscontestPaymentPathId,
  getLogoutModalsPathId,
  getCustomCardModalsPathId,
}
